import { TRootState } from "../@types"

export const selectModalCMS = ( state: TRootState ) =>state.cms.cMSModalIsOpen

export const selectIsUpdateCMS = ( state: TRootState ) =>state.cms.isUpdateCMS

export const selectCMSForUpdate = ( state: TRootState ) =>state.cms.cMSForUpdate

export const selectCMSRefreshTable =  ( state: TRootState ) =>state.cms.refreshTableCMS
